import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import cn from 'classnames';
import Modal from '../../Modal/Modal';
import Heading from '../../Typography/Heading/Heading';
import styles from '../LoginModal/LoginModal.module.scss';
import Paragraph from '../../Typography/Paragraph/Paragraph';
import Link from '../../Link/Link';
import { useTranslation } from 'react-i18next';
import { Field, Form, Formik } from 'formik';
import TextInput from '../../Form/TextInput/TextInput';
import PasswordInput from '../../Form/PasswordInput/PasswordInput';
import Button from '../../Button/Button';
import { useNavigate } from 'react-router-dom';
import { Routes } from '../../../constants/routes';
import { useAppDispatch, useAppSelector } from '../../../store/reducers';
import { clearData, signup } from '../../../store/reducers/SignUp/signupSlice';
import { useSignUpValidationSchema } from '../../../validations/signup';
import TextError from '../../TextError/TextError';
import { firstLetterUpperCase } from '../../../helpers';
import Loader from '../../Loader/Loader';
import AuthIcons from '../LoginModal/AuthIcons/AuthIcons';
import PrivacyPolicy from '../../PrivacyPolicy/PrivacyPolicy';
const CreateAccount = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { error, isDataSend, pending } = useAppSelector((state) => state.signup);
    const signInValidationSchema = useSignUpValidationSchema();
    useEffect(() => {
        if (!error && isDataSend) {
            navigate(Routes.LOGIN);
            dispatch(clearData());
            return;
        }
    }, [error, isDataSend, navigate, dispatch]);
    const closeModal = () => {
        navigate(Routes.HOME);
        dispatch(clearData());
    };
    return (_jsxs(Modal, Object.assign({ className: styles.element, background: true, closeModal: closeModal }, { children: [_jsx(Heading, { className: styles.heading, title: t('create_your_account') }), _jsxs("div", Object.assign({ className: cn('d-flex align-items-center', styles.descBox) }, { children: [_jsx(Paragraph, { fontFamily: 'urbanist', size: 2, className: styles.desc, title: `${t('already_have_an_account')}?` }), _jsx(Link, { onClick: () => navigate(Routes.LOGIN), size: 2, text: t('sign_in') })] })), _jsx(Formik, Object.assign({ initialValues: {
                    email: '',
                    password: ''
                }, onSubmit: (values) => {
                    const parsedData = {
                        email: values.email,
                        password: values.password
                    };
                    dispatch(signup(parsedData));
                    dispatch(clearData());
                }, validationSchema: signInValidationSchema }, { children: ({ handleChange, handleBlur, values, handleSubmit }) => (_jsxs(Form, Object.assign({ onSubmit: handleSubmit }, { children: [_jsx(Field, { label: t('email_address'), className: "w-100", type: "email", onChange: handleChange, onBlur: handleBlur, name: "email", id: "email", value: values.email, component: TextInput }), _jsx(Field, { label: t('password'), className: "w-100", type: "password", name: "password", id: "password", onChange: handleChange, onBlur: handleBlur, hideIcon: true, value: values.password, component: PasswordInput }), _jsx(Field, { label: t('repeat_password'), className: "w-100", type: "password", name: "passwordConfirmation", id: "passwordConfirmation", onChange: handleChange, onBlur: handleBlur, hideIcon: true, value: values.password, component: PasswordInput }), pending ? (_jsx(Button, { className: cn(styles.button, 'w-100'), height: 'sm', size: '100', type: 'submit', text: "", icon: _jsx(Loader, { isTransparent: true }) })) : (_jsx(Button, { className: cn(styles.button, 'w-100'), height: 'sm', size: '100', type: 'submit', text: t('create_account') }))] }))) })), error && _jsx(TextError, { text: firstLetterUpperCase(error) }), _jsx(PrivacyPolicy, { className: styles.privacy, text: t('terms_privacy_agree'), textEnd: t('terms_of_use') }), _jsx(Paragraph, { className: cn(styles.continue, 'd-flex align-content-center justify-content-center'), title: t('or_continue_with') }), _jsx(AuthIcons, {})] })));
};
export default CreateAccount;
